import { useTranslation } from "react-i18next";
import {
	FrontendUserInfo,
	FrontendOrder,
	FrontendProductOrder,
} from "node-library/dist/portal";

import { UserType } from "node-library/dist/constants";
import {
	getAdminStatusColors,
	getAdminStatusString,
} from "../../../../helpers/orderHelper";
import { NeutralColor, SemanticColor } from "node-library/dist/colors";
import { DeleteIcon, UserIcon } from "../../../../common-components/svgIcons";
import { formatCustomDate } from "node-library/dist/helpers/date_helper";
import { roleMeetsRequirement } from "node-library/dist/helpers/request_helper";
import Restricted from "../../../../permissionProvider/Restricted";
import { Permission } from "../../../../permissionProvider/PermissionProvider";

interface Props {
	order: FrontendProductOrder;
	user: FrontendUserInfo | undefined;
	goToViewOrderDetails: () => void;

	goToOrderReportPage: () => void;

	deleteOrder: () => void;
}

export default function OrderRow(props: Props) {
	const { t: translation } = useTranslation();

	const {
		order,
		goToViewOrderDetails,
		goToOrderReportPage,
		user,
		deleteOrder,
	} = props;

	const statusString: string = getAdminStatusString(
		order.orderStatus,
		order.paid,
		translation
	);
	const statusColor: {
		backgroundColor: string;
		borderColor: string;
		textColor: string;
	} = getAdminStatusColors(
		order.orderStatus,
		order.orderViewedByAdmin,
		order.paid
	);

	//currently only used for admin view - submitted orders so always have the date
	const submissionTimeStr: string = formatCustomDate(order.submitted as Date);

	const orderRowItem: React.ReactNode = (
		<div
			key={order.orderId}
			className="order-list-view-row order-list-view-item-row typography-body-01"
			onClick={() => {
				goToViewOrderDetails();
			}}
		>
			<div
				className={`${
					!order.orderViewedByAdmin ? `typography-bold` : ``
				} order-list-view-row-barcode-section order-list-view-row-item`}
				style={{ gridColumn: "1" }}
			>
				{!order.orderViewedByAdmin && (
					<span
						style={{
							width: "8px",
							height: "8px",
							borderRadius: "50%",
							backgroundColor: SemanticColor.ERROR,
						}}
					></span>
				)}
				{order.shortId}
			</div>
			<div className="order-list-view-row-item" style={{ gridColumn: "2" }}>
				{submissionTimeStr.split(" | ")[0]}
				<div className="typography-caption">
					{submissionTimeStr.split(" | ")[1]}
				</div>
			</div>
			{/* <div className="order-list-view-row-item order-list-view-sample-count-row-item">
				{order.productCount}
			</div> */}

			<Restricted to={Permission.CLIENT_INFO}>
				<div className="order-list-view-row-item" style={{ gridColumn: "3" }}>
					{order.clientCompanyName}
					<div
						className="typography-caption"
						style={{
							display: "flex",
							gap: "5px",
							flexWrap: "wrap",
							color: NeutralColor.NEUTRAL_GREY_500,
						}}
					>
						<div style={{ display: "flex", gap: "3px", alignItems: "end" }}>
							<UserIcon
								size={20}
								strokeColor={NeutralColor.NEUTRAL_GREY_500}
								strokeWidth={1.5}
							/>
							{order.orderedBy}
						</div>
					</div>
				</div>
			</Restricted>

			<div className="order-list-view-row-item" style={{ gridColumn: "4" }}>
				<div
					className="typography-body-02 admin-order-status-box admin-status-box-small"
					style={{
						backgroundColor: statusColor.backgroundColor,
						border: `1px solid ${statusColor.borderColor}`,
						color: statusColor.textColor,
					}}
				>
					{statusString}
				</div>
			</div>
			{/* <div className="order-list-view-row-item">
				<div style={{ display: "flex", justifyContent: "center", gap: "5px" }}>
					{roleMeetsRequirement(user?.role as UserType, UserType.ADMIN) && (
						<div
							id={`delete-order=${order.shortId}`}
							style={{ cursor: "pointer" }}
							onClick={(e) => {
								e.stopPropagation();
								deleteOrder();
							}}
						>
							<DeleteIcon></DeleteIcon>
						</div>
					)}
				</div>
			</div> */}
		</div>
	);

	return orderRowItem;
}
